import request from '../request'
// 查询问卷答案内容
const getQuestionnaireResult = (data) => {
  return request.post('/api/wx/auth/getQuestionnaireResult', data)
}
// 调查问卷保存（弹窗取消的时候也会调用）
const saveIsQuestionnaire = (data) => {
  return request.post('/api/wx/auth/saveIsQuestionnaire', data)
}
// 对象数组
export default {
  getQuestionnaireResult,
  saveIsQuestionnaire
}
